import { useCallback, useEffect } from 'react';

type ClickAwayListenerProps = {
  anchorElement: HTMLElement | null;
  changeVisibility: (isShow: boolean) => void;
};

export const useClickAwayListener = ({ anchorElement, changeVisibility }: ClickAwayListenerProps) => {
  const handleClickOutSide = useCallback(
    (e: MouseEvent) => {
      if (e.target instanceof HTMLElement && !anchorElement?.contains(e?.target)) {
        changeVisibility(false);
      }
    },
    [anchorElement, changeVisibility],
  );
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutSide);
    return () => {
      document.removeEventListener('mousedown', handleClickOutSide);
    };
  }, [handleClickOutSide]);
};
